import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'model';

const WithEmbededWrapper = <P extends object>(WrappedComponent: React.ComponentType<P>): React.FC<P> => {
  // eslint-disable-next-line react/display-name
  return (props) => {
    const beEmbedded = useSelector((state: RootState) => state.app.beEmbedded);
    if (beEmbedded) return null;
    return <WrappedComponent {...props} />;
  };
};

export default WithEmbededWrapper;
